import { memoize } from 'proxy-memoize';
import type { GetEffectiveDimensionsFactory } from '../coordinates/geometry';
import type { PageLayoutSlice } from '../store/types';
import { calculateLayout, type LayoutBandHeights } from './calculate-layout';
import type { DocumentLayout } from './types';

/**
 * Creates a memoized selector for document layout.
 * Accepts a state-aware `getEffectiveDimensions` factory so that
 * proxy-memoize can track which state properties affect dimensions
 * (e.g. rotation values) and invalidate correctly.
 */
export const createSelectDocumentLayout = <TState extends PageLayoutSlice>(
  getEffectiveDimensions: GetEffectiveDimensionsFactory<TState>,
  bands?: LayoutBandHeights
) =>
  memoize(
    (state: TState): DocumentLayout =>
      calculateLayout(state.pageLayout.order, state.pageLayout.list, {
        getEffectiveDimensions: getEffectiveDimensions(state),
        bands,
      })
  );
